import { create } from 'zustand'

import { ICoin } from '@src/types/token'

type ErrorType = {
    message: string
}

interface LandingState {
    sign: string
    tokens: ICoin[]
    error: ErrorType
    setConnectedSign: (o: { sign: string }) => void
}

const useLandingStore = create<LandingState>((set, get) => ({
    sign: '',
    tokens: [],
    error: { message: '' },
    setConnectedSign: (o: { sign: string }) => set({ sign: o.sign }),
}))

export default useLandingStore
